// extracted by mini-css-extract-plugin
module.exports = {"root":"ConfirmAccount_root__4T53s","halfWidth":"ConfirmAccount_halfWidth__3zcnE","marginBottom":"ConfirmAccount_marginBottom__2fx30","buttons":"ConfirmAccount_buttons__3UuWx"};